import { render, staticRenderFns } from "./TermsAccept.vue?vue&type=template&id=25f33fea&"
import script from "./TermsAccept.vue?vue&type=script&lang=js&"
export * from "./TermsAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports